<template>
    <div class="pa-6 h-full">
        <!-- Limite de uso para plano Starter -->
        <v-row v-if="isStarter" class="mb-4">
            <v-col cols="12">
                <h2 class="text-h5 mb-3">Uso do Plano {{ profileName }}</h2>
            </v-col>
            <v-col cols="12" md="4">
                <limit-progress-card
                    title="Clientes"
                    icon="mdi-account-group"
                    :current="stats.customers"
                    :limit="limits.max_customers"
                />
            </v-col>
            <v-col cols="12" md="4">
                <limit-progress-card
                    title="Sessões este Mês"
                    icon="mdi-calendar-check"
                    :current="stats.sessions"
                    :limit="limits.max_monthly_sessions"
                />
            </v-col>
            <v-col cols="12" md="4">
                <v-card>
                    <v-card-title>
                        <v-icon left>mdi-history</v-icon>
                        Histórico
                    </v-card-title>
                    <v-card-text>
                        <div class="text-center">
                            <div class="text-h4 primary--text font-weight-bold">
                                {{ limits.history_days || 0 }}
                            </div>
                            <div class="text-caption grey--text">dias disponíveis</div>
                        </div>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        
        <the-graphics />
    </div>
</template>

<script>
import TheGraphics from './components/TheGraphics.vue';
import { mapState, mapGetters } from 'vuex';
import dayjs from 'dayjs';

export default {
    components: {
        TheGraphics
    },
    data() {
        return {
            stats: {
                customers: 0,
                sessions: 0
            }
        };
    },
    computed: {
        ...mapState("schedule", {
            alerts: state => state.alerts_today
        }),
        ...mapGetters('auth', ['isStarter', 'isPro', 'limits', 'profileName'])
    },
    async mounted() {
        await this.loadStats();
    },
    methods: {
        getAge(birthday) {
            return dayjs().diff(dayjs(birthday), 'year');
        },
        
        async loadStats() {
            // Carregar estatísticas apenas para usuários Starter
            if (!this.isStarter) return;
            
            try {
                const [customers, sessions] = await Promise.all([
                    this.$store.dispatch('utils/ActionGetCustomersCount'),
                    this.$store.dispatch('utils/ActionGetMonthlySessionsCount')
                ]);
                
                this.stats.customers = customers.count;
                this.stats.sessions = sessions.count;
            } catch (error) {
                console.error('Erro ao carregar estatísticas:', error);
            }
        }
    }
};
</script>
